
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tapahtuma/[event]",
      function () {
        return require("private-next-pages/tapahtuma/[event].js");
      }
    ]);
  